import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function WebsiteDevelopment() {
    return (

        <div className="inner-page about contact-page servi-ce-details">

            <Header />


            <div className="rts-breadcrumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="baread-crumb-main-wrapper pt--100">
                                <div className="inner">
                                    <h1 className="title rts_hero__title">Digital marketing</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service-details-area rts-section-gapTop bg-dark-s">
                <div className="container-150">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="main-page-title-service-left-area">
                                <div className="left">
                                    <h1 className="title-page rts_hero__title">
                                    Enhance Your Brand Visibility through<br /> our Digital Marketing Solutions
                                    </h1>
                                    <div className="bottom-content">
                                        <p className="disc">
                                        Warmonks takes pride in its experience in providing digital marketing solutions supported by proven track records. Over many successful projects,<br /> we have helped businesses increase their online presence and obtain exceptional results. With our professional team, you get customized strategies<br /> suited to your requirements for maximum effect. We start by getting you targeted traffic, increasing brand awareness, and driving your business toward<br /> success in this changing digital world through innovation, expertise, and dedication.</p>                                        {/* <div className="check-area-main-sd">
                                            <div className="single-check">
                                                <i className="fa-light fa-check"></i>
                                                <p>Content & Software Engineering</p>
                                            </div>
                                            <div className="single-check">
                                                <i className="fa-light fa-check"></i>
                                                <p>Artificial Intelligence and Learning New</p>
                                            </div>
                                            <div className="single-check">
                                                <i className="fa-light fa-check"></i>
                                                <p>Digital Service Platform</p>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="right">
                                    <div className="top-center-image circle-speen rts-scroll-down-circle-wrapper-3">
                                        <a href="#" className="speen-shape scroll-down-circle-3">
                                            <svg className="uni-circle-text-path uk-text-secondary uni-animation-spin"
                                                viewBox="0 0 100 100" width="180" height="180">
                                                <defs>
                                                    <path id="circle"
                                                        d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" />

                                                </defs>
                                                <text font-size="11.75">
                                                    <textPath xlinkHref="#circle">Project SHowcase • Project SHowcase •
                                                    </textPath>
                                                </text>
                                            </svg>
                                            <i className="fa-solid fa-star-sharp"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row pt--80 pt_md--10 pt_sm--0">
                        <div className="col-xl-9 col-lg-12 pr--60 pr_md--15 pr_sm--10 pb_sm--30">

                            <div className="service-details-left">
                                <div className="thumbnaiul-large">
                                    <img src="assets/images/service/04.jpg" alt="service-details" />
                                </div>
                            </div>

                            <div className="single-para-title-service-details mt--40">
                                <h3 className="title">Our Digital Marketing Services </h3>
                                <p className="disc">
                                Our Content Marketing services deliver high-quality, compelling content that builds brand authority, engages your audience, and drives conversions. Through Email Marketing, we help nurture leads and build lasting customer relationships with personalized campaigns that add value. Lastly, our Conversion Rate Optimization (CRO) ensures that your website and campaigns are optimized to turn visitors into loyal customers, driving sustainable growth for your business.</p>                            </div>

                            <div className="single-para-title-service-details mt--40">
                                <h3 className="title">Elevate Your Online Presence with Warmonks </h3>
                                <p className="disc">
                                Warmonks is the leading digital marketing company in Kerala that businesses have entrusted with innovation and results-based strategies. Excellence is our guarantee, and experience, combined with a passion for brands to succeed, sets us beyond conventional marketing approaches in creating a powerful campaign to spur growth. From increasing visibility to engaging with audiences or maximizing conversion rates, Warmonks is your ideal digital success partner. Let's help you lift your brand to its rightful position of leadership in this competitive digital space.</p>                                </div>

                            {/* <div className="image-thumbnail-2-service-d mt--50">
                                <div className="row g-4">
                                    <div className="col-lg-5">
                                        <div className="thumbnail-service">
                                            <img src="assets/images/service/05.jpg" alt="service" />
                                        </div>
                                    </div>
                                    <div className="col-lg-7">
                                        <div className="thumbnail-service">
                                            <img src="assets/images/service/06.jpg" alt="service" />
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            <div className="faq-section-start-left-img mt--80">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-12">
                                        <div className="thumbnail">
                                            <img src="assets/images/service/07.png" alt="service_images" />
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-12 pl--50 pl_lg--0">

                                        <div className="service-details-accordion-area">
                                            <h3 className="title">Why choose Warmonks for Digital Marketing?</h3>
                                            <div className="accordion" id="accordionExample">
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingOne">
                                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                                            data-bs-target="#collapseOne" aria-expanded="true"
                                                            aria-controls="collapseOne">
                                                            Customized Strategies
                                                        </button>
                                                    </h2>
                                                    <div id="collapseOne" className="accordion-collapse collapse show"
                                                        aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <p>Every business is different, and that's why we make marketing strategies customized to the goals of the company.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingTwo">
                                                        <button className="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                                            aria-expanded="false" aria-controls="collapseTwo">
                                                            Data-Driven Approach
                                                        </button>
                                                    </h2>
                                                    <div id="collapseTwo" className="accordion-collapse collapse"
                                                        aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <p>Using analytics and insights, we optimize our campaigns for the highest ROI, and every effort must result in meaningful results.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingThree">
                                                        <button className="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                            aria-expanded="false" aria-controls="collapseThree">
                                                            Comprehensive Services
                                                        </button>
                                                    </h2>
                                                    <div id="collapseThree" className="accordion-collapse collapse"
                                                        aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <p>We cover every area of digital marketing, including SEO, social media marketing, content creation, and paid advertising.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingFour">
                                                        <button className="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapseFour"
                                                            aria-expanded="false" aria-controls="collapseFour">
                                                            Proven Track Record
                                                        </button>
                                                    </h2>
                                                    <div id="collapseFour" className="accordion-collapse collapse"
                                                        aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <p>Our portfolio includes successful campaigns across various industries, which reflect our ability to create impactful results.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-12 mt_lg--50 rts-sticky-column-item">
                            <div className="theiaStickySidebar">
                                <div className="rts-single-wized Categories">
                                    <div className="wized-header">
                                        <h5 className="title">
                                            All Services
                                        </h5>
                                    </div>
                                    <div className="wized-body">

                                        <ul className="single-categories">
                                            <li><a href="/websitedevelopment">Website Development <i className="far fa-long-arrow-right"></i></a></li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/appdevelopment">App Development<i className="far fa-long-arrow-right"></i></a>
                                            </li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/ecommercedevelopment">Ecommerce Development<i className="far fa-long-arrow-right"></i></a>
                                            </li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/digitalmarketing">Digital Marketing<i className="far fa-long-arrow-right"></i></a></li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/seo">SEO<i className="far fa-long-arrow-right"></i></a></li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/graphicsdesigning">Graphic Designing <i className="far fa-long-arrow-right"></i></a></li>
                                        </ul>

                                    </div>
                                </div>
                                {/* <div className="rts-single-wized Categories">
                                    <div className="wized-header">
                                        <h5 className="title">
                                            Let's start new project.
                                        </h5>
                                    </div>
                                    <div className="wized-body">
                                        <form className="service-details-form" action="#">
                                            <input type="text" placeholder="Your name" />
                                            <input type="text" placeholder="Phone number" />
                                            <textarea placeholder="Message"></textarea>
                                            <button>Start Project</button>
                                        </form>
                                    </div>
                                </div> */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <Footer />

            <div className="loading-screen" id="loading-screen">
                <span className="bar top-bar"></span>
                <span className="bar down-bar"></span>
                <span className="progress-line"></span>
                <span className="loading-counter"> </span>
            </div>


            <div className="bg-noise"></div>



            <div className="progress-wrap">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
                </svg>
            </div>

            <div className="rts-cursor cursor-outer" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor"></span>
            </div>
            <div className="rts-cursor cursor-inner" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor">
                    <span className="fn-left"></span>
                    <span className="fn-right"></span>
                </span>
            </div>

            <div className="modal-sidebar-scroll rts-dark-light">
                <ul>
                    <li className="go-dark-w"><span>Dark</span><i className="rts-go-dark fal fa-moon"></i></li>
                    <li className="go-light-w"><span>Light</span><i className="rts-go-light fa-light fa-brightness"></i></li>
                </ul>
            </div>


        </div>
    )
}

export default WebsiteDevelopment
